module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-dtg-cdbc56100f1898ed9078541f2eea01fe.svg";